//extracted by mini-css-extract-plugin
export default {"container":"styles_container__adZSW","item":"styles_item__QXCSC","link":"styles_link__hXvue"};;